<template>
    <div>
        Route fee partner
    </div>
</template>

<script setup lang="ts"></script>
